import React from 'react'

import InfiniteScroll from 'react-infinite-scroll-component'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import BrandFanInfluencerIdentityRow from '@components/BrandFans/InfluencerIdentity/Row'
import Loading from '@components/UI/Loading'
import { IApplicationState } from '@store'
import {
  fetchBrandFanGroupMembers,
  selectBrandFanGroupMembers,
  selectBrandFansGroupMembersNextLink,
  selectGroupMembersIdentityIds,
  selectIsFetchingIdentities,
} from '@store/brandFans'
import { Container } from '@tribegroup'
import { isEmpty } from '@utils'

interface IProps {
  groupId: number
}

const BrandFansGroupMemberList: React.FC<IProps> = ({ groupId }) => {
  const dispatch = useDispatch()
  const isFetching = useSelector((state: IApplicationState) => selectIsFetchingIdentities(state))
  const memberIdentityIds = useSelector(
    (state: IApplicationState) => selectGroupMembersIdentityIds(state, groupId),
    shallowEqual,
  )
  const hasMore = useSelector((state: IApplicationState) =>
    Boolean(selectBrandFansGroupMembersNextLink(state, groupId)),
  )
  const members = useSelector(
    (state: IApplicationState) => selectBrandFanGroupMembers(state, groupId),
    shallowEqual,
  )

  React.useEffect(() => {
    dispatch(fetchBrandFanGroupMembers(groupId))
  }, [])

  if (isFetching && isEmpty(memberIdentityIds)) {
    return <Loading height={30} />
  }

  const fetchNext = () => {
    dispatch(fetchBrandFanGroupMembers(groupId, true))
  }

  return (
    <Container topOuterSpacing={0.75} bottomInnerSpacing={6.25}>
      <InfiniteScroll
        dataLength={memberIdentityIds.length}
        next={fetchNext}
        loader={<Loading height={30} />}
        hasMore={hasMore}
        scrollThreshold={0.8}
        style={{ overflow: 'hidden' }}
      >
        <div data-testid="brand-fans-group-members-identity-list">
          {members.map((member) => (
            <BrandFanInfluencerIdentityRow
              key={member.id}
              identityId={member.identity_id}
              brandFanMemberId={member.id}
              brandFanGroupId={groupId}
            />
          ))}
        </div>
      </InfiniteScroll>
    </Container>
  )
}

export { BrandFansGroupMemberList }
export default BrandFansGroupMemberList
